export const enumPermisosTranscaribe = Object.freeze({
  RECARGA_TARJETAS_TRANSCARIBE: 35000,
});
